import { ApiResult, HttpClient } from "../http.js";
import { GuestKsDto, GuestTimeplanDto } from "../types/guests.js";

/**
 * Token-authenticated, unauthenticated-session reads for the public guest pages (tidsplan / KS).
 * Replaces the legacy Firebase callables (`getGuestTimeplan`, `getGuestKS`). The guest token is
 * passed as the `?token=` query parameter; the server validates it via the guest-token system.
 * There is no session cookie or bearer token, so a guest client should be constructed without
 * `credentials: "include"`.
 */
export class GuestsApi {
  constructor(private readonly http: HttpClient) {}

  /**
   * Returns the customer-facing KS (quality schema) for the project associated
   * with the token. Mirrors the legacy Firebase callable `getGuestKS`.
   * `GET /api/guests/ks/view?token=…`
   */
  ksView(token: string): Promise<ApiResult<GuestKsDto>> {
    return this.http.get<GuestKsDto>("/api/guests/ks/view", {
      query: { token },
    });
  }

  /** Returns the customer-facing timeplan for the project the token grants access to. */
  getTimeplan(token: string): Promise<ApiResult<GuestTimeplanDto>> {
    return this.http.get<GuestTimeplanDto>("/api/guests/timeplans/view", {
      query: { token },
    });
  }
}
